// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "wrapper-3n5Ba";
var _4 = "title-2k3Yo";
var _5 = "inputs-1gYBJ";
var _6 = "input-eg1Vz";
var _7 = "input_root-1Yr57";
var _8 = "spoilers-2P-1K";
var _9 = "spoiler-3QeuP";
var _a = "spoilerExpanded-2e57b";
var _b = "spoilerHeader-3pnFP";
var _c = "spoilerHeaderExpended-28E9J";
var _d = "spoilerHeaderContent-1PNQc";
var _e = "spoilerDetails-QmwUD";
var _f = "footer-3sXxJ";
var _10 = "button-35VNC";
var _11 = "buttonCancel-1PlF9";
var _12 = "buttonContinue-knH-W";
var _13 = "buttonDisabled-ZLb6c";
var _14 = "preview-1juE4";
var _15 = "preview_title-bqnG6";
var _16 = "preloader-dYZnb";
export { _1 as "__esModule", _2 as "mobile", _3 as "wrapper", _4 as "title", _5 as "inputs", _6 as "input", _7 as "input_root", _8 as "spoilers", _9 as "spoiler", _a as "spoilerExpanded", _b as "spoilerHeader", _c as "spoilerHeaderExpended", _d as "spoilerHeaderContent", _e as "spoilerDetails", _f as "footer", _10 as "button", _11 as "buttonCancel", _12 as "buttonContinue", _13 as "buttonDisabled", _14 as "preview", _15 as "preview_title", _16 as "preloader" }
export default { "__esModule": _1, "mobile": _2, "wrapper": _3, "title": _4, "inputs": _5, "input": _6, "input_root": _7, "spoilers": _8, "spoiler": _9, "spoilerExpanded": _a, "spoilerHeader": _b, "spoilerHeaderExpended": _c, "spoilerHeaderContent": _d, "spoilerDetails": _e, "footer": _f, "button": _10, "buttonCancel": _11, "buttonContinue": _12, "buttonDisabled": _13, "preview": _14, "preview_title": _15, "preloader": _16 }
